import * as React from 'react';
import {cn} from '../lib/cn';

export interface DefaultSelectTriggerProps extends React.HTMLAttributes<HTMLDivElement> {
  disabled?: boolean;
  empty?: boolean;
  readOnly?: boolean;
  width?: string;
  loading?: boolean;
  invalid?: boolean;
}

export const DefaultSelectTrigger = React.forwardRef<
  HTMLDivElement,
  DefaultSelectTriggerProps
>(
  (
    {
      className,
      disabled,
      empty,
      readOnly,
      width,
      loading,
      invalid: _invalid,
      children,
      ...props
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          'relative box-border flex items-center justify-between',
          'min-h-[var(--default-select-trigger-height)] rounded-[var(--default-select-trigger-radius)] bg-[var(--default-select-trigger-bg)] shadow-none',
          'pointer-events-auto px-[14px] font-medium',
          'transition-colors duration-500',
          disabled &&
            'cursor-progress opacity-[var(--default-select-trigger-disabled-opacity)]',
          disabled && '[&_.select__control]:cursor-not-allowed',
          loading && 'cursor-progress',
          loading && '[&_.select__control]:cursor-progress',
          (empty || readOnly) &&
            'border-0 bg-[var(--default-select-trigger-empty-bg)] text-[var(--default-select-trigger-empty-text)] hover:border-0',
          !disabled && !loading && 'cursor-pointer',
          className,
        )}
        style={{width: width ? `${width}px` : 'var(--default-select-trigger-width)'}}
        {...props}
      >
        {children}
      </div>
    );
  },
);

DefaultSelectTrigger.displayName = 'SelectTrigger';
